module.exports = __webpack_public_path__ + "static/media/marker-icon-red.c7da396d.svg";